import { AssemblyPriceTable } from '@/models/assembly.model';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssemblyPricesService {
    assemblyPrices = signal<AssemblyPriceTable[]>([]);
    clonedPrices= signal<{ [key: string]: AssemblyPriceTable }>({});
    removedPrices = signal<AssemblyPriceTable[]>([]);

  constructor() { }

  setAssemblyPrices(prices: AssemblyPriceTable[]) {
    this.assemblyPrices.set(prices);
  }

  addAssemblyPrice(price: AssemblyPriceTable) {
    this.assemblyPrices.update(prices => [...prices, price]);
  }

  removeAssemblyPrice(price: AssemblyPriceTable) {
    if(price.APID > 0) {
      this.assemblyPrices.update(prices => prices.filter(p => p.APID !== price.APID));
    } else {
      this.assemblyPrices.update(prices => prices.filter(p => p.PlanID !== price.PlanID));
    }
  }

  updateAssemblyPrice(price: AssemblyPriceTable) {
    this.assemblyPrices.update(prices => prices.map(p => p.PlanID === price.PlanID ? price : p));
  }

  clearAssemblyPrices() {
    this.assemblyPrices.set([]);
  }

  updateSpecificClone(price: AssemblyPriceTable, key: string) {
    this.clonedPrices.update(clonedPrices => ({...clonedPrices, [key]: price}));
  }

addToRemovedPrices(price: AssemblyPriceTable) {
  this.removedPrices.update(removedPrices => [...removedPrices, price]);
  console.log(this.removedPrices());
}

removeFromRemovedPrices(price: AssemblyPriceTable) {
  this.removedPrices.update(removedPrices => removedPrices.filter(p => p.PlanID !== price.PlanID));
}
  
  
}
